import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PrimeNgModule } from "@primeng";
import { DashboardService } from "@main/reporting.v3/dashboard/api/dashboard.service";
import { HtmlRendererModule } from "@main/reporting.v3/html-renderer/html-renderer.module";
import {
    ReportingDashboardPdfLayoutEditorComponent
} from "@main/reporting.v3/dashboard/components/dashboard-pdf-layout-editor.component";
import {
    ReportingDashboardBuilderComponent
} from "@main/reporting.v3/dashboard/components/dashboard-builder.component";
import {
    ReportingDashboardQueriesComponent
} from "@main/reporting.v3/dashboard/components/dashboard-queries.component";
import { ReportingDashboardComponent } from "@main/reporting.v3/dashboard/components/dashboard.component";
import {
    DashboardAuthorizationInterceptor
} from "@main/reporting.v3/dashboard/api/dashboard-authorization-interceptor";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { WidgetModule } from "@main/reporting.v3/widget/widget.module";
import { WidgetGridModule } from "@main/reporting.v3/widget.grid/widget-grid.module";
import { WidgetChartModule } from "@main/reporting.v3/widget.chart/widget-chart.module";
import { WidgetControlSetModule } from "@main/reporting.v3/widget.control-set/widget-control-set.module";
import { WidgetHtmlModule } from "@main/reporting.v3/widget.html/widget-html.module";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { CssEditorModule } from "@controls/text-editors/css-editor/css-editor.module";
import { QueryBuilderModule } from "@main/reporting.v3/query-builder/query-builder.module";
import { DashboardPdfExportingService } from "@main/reporting.v3/dashboard/api/dashboard-pdf-exporting.service";
import { DashboardAuxiliaryService } from "@main/reporting.v3/dashboard/api/dashboard-auxiliary.service";
import { DashboardXlsExportingService } from "@main/reporting.v3/dashboard/api/dashboard-xls-exporting.service";
import { DashboardQueryService } from "@main/reporting.v3/dashboard/api/dashboard-query.service";
import { HtmlEditorModule } from "@controls/text-editors/html-editor/html-editor.module";
import { ReportingCoreModule } from "@main/reporting.v3/reporting-core.module";
import { GridModule } from "@features/grid";


@NgModule({
    declarations: [
        ReportingDashboardPdfLayoutEditorComponent,
        ReportingDashboardBuilderComponent,
        ReportingDashboardQueriesComponent,
        ReportingDashboardComponent
    ],
    providers: [{
        provide: HTTP_INTERCEPTORS,
        useClass: DashboardAuthorizationInterceptor,
        multi: true
    },
        DashboardPdfExportingService,
        DashboardXlsExportingService,
        DashboardAuxiliaryService,
        DashboardQueryService,
        DashboardService
    ],
    exports: [
        ReportingDashboardPdfLayoutEditorComponent,
        ReportingDashboardBuilderComponent,
        ReportingDashboardComponent
    ],
    imports: [
        GridModule,
        CommonModule,
        PrimeNgModule,
        BbwtSharedModule,
        WidgetGridModule,
        WidgetChartModule,
        WidgetControlSetModule,
        WidgetHtmlModule,
        WidgetModule,
        CssEditorModule,
        HtmlEditorModule,
        HtmlRendererModule,
        QueryBuilderModule,
        ReportingCoreModule,
    ]
})
export class DashboardModule {
}